/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { FilledButton, ToasterControlled } from '@neo4j-ndl/react';
import { useState } from 'react';

const Component = () => {
  const [toasts, setToasts] = useState<
    React.ComponentProps<typeof ToasterControlled>['toasts']
  >([]);

  return (
    <div className="n-flex n-justify-center">
      {/* Toaster should be at the root of the app */}
      <ToasterControlled toasts={toasts} />
      <FilledButton
        onClick={() => {
          setToasts([
            ...toasts,
            {
              id: '1',
              text: 'Hi there!',
              variant: 'neutral',
              onClose: () => {
                setToasts(toasts.filter((toast) => toast.id !== '1'));
              },
            },
          ]);
        }}
      >
        Press to show a Toast
      </FilledButton>
    </div>
  );
};

export default Component;
